const Warning = ({text}) => {
  return (
    <div>
      <p>{text}</p>
    </div>
  )
}

export { Warning }